var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.ssr
        ? _vm._t("body")
        : [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "breadcrumb-container" }, [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ul",
                    { staticClass: "breadcrumb pl-0" },
                    _vm._l(_vm.breadcrumb, function(breadcrumb_item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "breadcrumb-item",
                          class: {
                            active:
                              breadcrumb_item["title"] ==
                              _vm.breadcrumb[_vm.breadcrumb.length - 1]["title"]
                          }
                        },
                        [
                          breadcrumb_item["url"] != undefined
                            ? _c("a", {
                                attrs: { href: breadcrumb_item["url"] },
                                domProps: {
                                  innerHTML: _vm._s(breadcrumb_item["title"])
                                }
                              })
                            : _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(breadcrumb_item["title"])
                                }
                              })
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }